const duoAppTokens = {
  TODESCHINI: "2y10Cyc6oTdrY31N50O1fNWLAOZG06SPijThRlgd8o03nwMzh0bNWmi",
  CRIARE: "2y10RlD4r7uQCM6fMnSONSDvQNwt0xY0XPRmxYKemOUAzQfEUBoYHhS",
  ITALINEA: "2y10cqqAWZKHtMAy7ISUs7WucbwpfBW6YYp8gW482OvieBwX1J5s",
};

const cmsTokens = {
  TODESCHINI: "$2y$10$LrhEus1u5xiypPHz48NVKemAPzM3WE2LW79A01szqH1aocSGm2NaS",
  CRIARE: "$2y$10$yNv.yR8j3awni/smL8ILdO.0sb5RytwmZZ4QqygQN.NYBB9iIZ8fG",
  ITALINEA: "$2y$10$fqHnV.C/ZWw0JToDoV2J/.Hi/0tY7Cp32mw7hRJLDHCqxRYf7lOLK",
};

export { cmsTokens as tokens };
